/**
 * App Store IDs and package names for all Anihis mobile apps.
 * Update these values when apps are published to the stores.
 */
export const AppStoreIds = {
  vetApp: {
    appleId: '6759968869',
    androidPackage: 'com.anihis.veterinarian.app',
  },
  clientApp: {
    appleId: '6759907246',
    androidPackage: 'com.anihis.app',
  },
} as const;

export const AppStoreUrls = {
  vetApp: {
    ios: `https://apps.apple.com/app/id${AppStoreIds.vetApp.appleId}`,
    android: `https://play.google.com/store/apps/details?id=${AppStoreIds.vetApp.androidPackage}`,
  },
  clientApp: {
    ios: `https://apps.apple.com/app/id${AppStoreIds.clientApp.appleId}`,
    android: `https://play.google.com/store/apps/details?id=${AppStoreIds.clientApp.androidPackage}`,
  },
} as const;
